module.exports = __webpack_public_path__ + "img/6769855.png";